import common from './common';

export function translate(key, l = null) {
    let str = key || '';
    if (str.length > 0) {
        const split = str.split('.');
        split.push(l || common.config.language || 'en');
        let i;
        let length;
        let t = common.config.strings;
        for (i = 0, length = split.length; i < length; ++i) {
            t = t[split[i]];
            if (!t) break;
        }
        i === split.length && (str = t);
    }
    return str;
}

export function localeFont() {
    if (specialCharacters())
        return "Lubalin Graph ITC Turner Ara Bold";
    else
        return "LubalinGraphITCTurner-Bold";
}

export function specialCharacters() {
    return common.config.language === "ar"/* || common.config.language === "pl" || common.config.language === "ro" || common.config.language === "cz"*/;
}
